import $ from 'jquery';

"use strict";

var ViewAccountAddresses = Backbone.View.extend({

  initialize: function () {
    this.fulfillments = window.ORW.fulfillments;
    this.initShippingTrackingInfo();

    // this.initTdWidths();
  },

  events: {},

  initShippingTrackingInfo: function () {
    var $container = $('#order-container #fulfillment-info');
    if (!this.fulfillments.length) return $container.css('display', 'none');

    // filter duplicates
    var fulfillments = this.fulfillments.filter((function (fulfillment, index, self) {
      return self.findIndex(function (f) {
        return fulfillment.trackingNumber === f.trackingNumber && fulfillment.id !== f.id;
      }) !== index;
    }));

    var dates = fulfillments.map(function (fulfillment) {
      var str = fulfillment.date;
      if (fulfillment.company) str += (' via ' + fulfillment.company);
      return str;
    });

    var trackingNumbers = fulfillments.map(function (fulfillment) {
      console.log('<a ' +
      'href="' + fulfillment.url + '" ' +
      'target="_blank" ' +
      'rel="noopener noreferrer">' + fulfillment.trackingNumber + '</a>')
      return '<a ' +
      'href="' + fulfillment.url + '" ' +
      'target="_blank" ' +
      'rel="noopener noreferrer">' + fulfillment.trackingNumber + '</a>';
    });

    $container.find('#date-and-company').html(dates.join(', '));
    $container.find('#tracking-number').html(trackingNumbers.join(', '));
  },

  initTdWidths: function () {
    var tds = $('#order-container td:first-child');

    var tdWidths = tds.map(function () { return $(this).width(); }).get();
    var maxTdWidth = Math.ceil(Math.max.apply(null, tdWidths)) + 1;

    var divWidths = tds.map(function () { return $(this).find('div').width(); }).get();
    var maxDivWidth = Math.ceil(Math.max.apply(null, divWidths)) + 1;

    if (maxTdWidth > maxDivWidth - 30) {
      tds.each(function () { $(this).width(maxDivWidth + 30); });
    }
  },

});

export default ViewAccountAddresses;